const BASE_URL = process.env.REACT_APP_SERVER_DOMAIN;
const BASE_URL_EVAL = process.env.REACT_APP_EVALUTION_DOMAIN;

const CONTENT_TYPES = {
  APPLICATION_JSON: "application/json",
  MULTIPART_FORM_DATA: "multipart/form-data",
};

const API_ENDPOINT_ADD_IDP_PROJECT = "/upload";
const API_ENDPOINT_CREATE_EXISTING_IDP_EVAL_WITH_FILE = "/create_new_project/";
const API_ENDPOINT_CREATE_NEW_EVAL = "/upload_context_aware_file/";
const AUTH_TOKEN_KEY = "auth_token";

const USER_BY_ROLE = "user/users-by-role";
const UPDATE_USER = "user/";
const CREATE_USER = "user/create";
const USER_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

const EXPENSE_STATUS = {
  PAID: "Paid",
  REJECTED: "Rejected",
};

const PAYMENT_MODE = {
  BANK_TRANSFER: "Bank",
  CASH: "Cash",
  CHEQUE: "Cheque",
};

const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  MANAGING_DIRECTOR: "MANAGING_DIRECTOR",
  PROGRAM_MANAGER: "PROGRAM_MANAGER",
  SUPERVISOR: "SUPERVISOR",
  TEACHER: "TEACHER",
  ACCOUNTANT: "ACCOUNTANT",
  OFFICE_STAFF: "OFFICE_STAFF",
};

const ROLE_NAME = {
  SUPER_ADMIN: "Super Admin",
  MANAGING_DIRECTOR: "Managing Director",
  PROGRAM_MANAGER: "Program Manager",
  SUPERVISOR: "Supervisor",
  TEACHER: "Teacher",
  ACCOUNTANT: "Accountant",
  OFFICE_STAFF: "Office Staff",
  NO_ROLE: "No role",
};

const ATTENDANCE_STATUS = {
  PUNCH_IN: "PUNCH_IN",
  PUNCH_OUT: "PUNCH_OUT",
};

const NOTIFICATION_FILTER = [
  {label: "All", value: "all"},
  {label: "Read", value: "read"},
  {label: "Unread", value: "unread"},
];

const CONFIRM_STATUS = {
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  REJECTED: "Rejected",
};

const ATTENDANCE_CONFIRM_STATUS = {
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  REJECTED: "Rejected",
};

const TOAST_AUTOCLOSE_DURATION = 2000;

const REFERENCE = {
  ATTENDANCE: "ATTENDANCE",
  EXPENSE: "EXPENSE",
  MONTHLY_EXPENSE: "MONTHLY_EXPENSE",
  MONTHLY_HONORARIUM: "MONTHLY_HONORARIUM",
  SCHOLARSHIP: "SCHOLARSHIP",
  APPROVAL_REQUEST: "APPROVAL_REQUEST",
};

const APPROVAL_REQUEST_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

const APPROVAL_REQUEST_MODULE = {
  MONTHLY_EXPENSE: "MONTHLY_EXPENSE",
  HONORARIUM: "HONORARIUM",
  TRANSACTION: "TRANSACTION",
  SCHOLARSHIP: "SCHOLARSHIP",
};

export {
  BASE_URL,
  BASE_URL_EVAL,
  CONTENT_TYPES,
  TOAST_AUTOCLOSE_DURATION,
  API_ENDPOINT_ADD_IDP_PROJECT,
  API_ENDPOINT_CREATE_EXISTING_IDP_EVAL_WITH_FILE,
  API_ENDPOINT_CREATE_NEW_EVAL,
  AUTH_TOKEN_KEY,
  USER_BY_ROLE,
  UPDATE_USER,
  USER_STATUS,
  ROLES,
  CREATE_USER,
  ATTENDANCE_STATUS,
  ROLE_NAME,
  EXPENSE_STATUS,
  PAYMENT_MODE,
  NOTIFICATION_FILTER,
  CONFIRM_STATUS,
  REFERENCE,
  ATTENDANCE_CONFIRM_STATUS,
  APPROVAL_REQUEST_STATUS,
  APPROVAL_REQUEST_MODULE,
};
